module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg6": "",
      "offset-sm3": ""
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('v-card-media', {
    attrs: {
      "src": "/static/doc-images/lists/samadhi.jpg",
      "height": "200px"
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-end": "",
      "flexbox": ""
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [
    [_c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "avatar": "",
        "to": {
          name: 'Donations'
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "/static/doc-images/lists/shake-hand.png"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  Regular Donations to Trust\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "avatar": "",
        "to": {
          name: 'bio'
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "/static/doc-images/lists/bio.png"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  Biography\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "avatar": "",
        "to": {
          name: 'air'
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "/static/doc-images/lists/how to reach.png"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  How to reach\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "avatar": "",
        "to": {
          name: 'piligrim'
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "static/doc-images/lists/Accomdation.png"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  Accommodation\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "avatar": "",
        "href": _vm.liveUrl,
        "target": "_blank"
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "/static/doc-images/lists/samadhi.jpg"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n\t\t\t\t\t\t\t\t\tAMB Tomb Shrine Virtual Darshan\n\t\t\t\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "avatar": "",
        "to": {
          name: 'Prayers'
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "/static/doc-images/lists/prayer.png"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  Prayers\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "avatar": "",
        "href": _vm.libraryUrl,
        "target": "_blank"
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "/static/doc-images/lists/digital-library-e-book.jpg"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  Online Library\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "href": _vm.eventUrl,
        "avatar": ""
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "/static/doc-images/lists/events.png"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  Events\n                ")])], 1)], 1)], 1)]
  ], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ee7bd2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 303
// module chunks = 1